import React from 'react';
import { connect } from 'react-redux';

import OperationalDashboard from '../index';
import OperationalDashboardCard from '../components/OperationalDashboardCard';
import IssuedInvoicesOnTerminal from '../components/CardContentTypes/IssuedInvoicesOnTerminal';
import VerticalBarsByState from '../components/CardContentTypes/VerticalBarsByState';
import InTransitInvoicesByStatus from '../components/CardContentTypes/InTransitInvoicesByStatus';
import { getDistributionData } from '../../../redux/operational-dashboard-distribution';
import LoadMask from '../../../components/LoadMask';
import './styles.css';

class Distribution extends React.Component {
  componentDidMount() {
    this.props.getDistributionData();
    this.interval = setInterval(() => {
      this.props.getDistributionData();
    }, 300000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const {
      data,
      isFetching,
    } = this.props;

    if (isFetching) {
      return <LoadMask text="Carregando" />;
    }

    return (
      <OperationalDashboard>
        {data &&
          <div className="container-fluid OperationalDashboard OperationalDashboard__flex">
            <div className="row padding OperationalDashboard__flex">
              <div className="col-md-6 OperationalDashboard__flex__col">
                <div className="row OperationalDashboard__flex2">
                  <OperationalDashboardCard
                    fullWidth
                    title="Notas fiscais no terminal"
                  >
                    <IssuedInvoicesOnTerminal
                      tons={data.atTheTerminal.tons}
                      invoices={data.atTheTerminal.invoices}
                      late={{
                        value: data.atTheTerminal.late.tons,
                        percentage: data.atTheTerminal.late.percentage,
                      }}
                      onTime={{
                        value: data.atTheTerminal.onTime.tons,
                        percentage: data.atTheTerminal.onTime.percentage,
                      }}
                    />
                  </OperationalDashboardCard>
                </div>
                <div className="row OperationalDashboard__flex2 ">
                  <OperationalDashboardCard
                    fullWidth
                    title="No terminal por estado (em toneladas)"
                  >
                    <VerticalBarsByState
                      selector="tons"
                      sufix=" tons"
                      states={data.invoicesAtTheTerminalByState.filter((state, key) => key < 10)}
                    />
                  </OperationalDashboardCard>
                </div>
              </div>
              <div className="col-md-6 OperationalDashboard__flex__col">
                <div className="row OperationalDashboard__flex2">
                  <OperationalDashboardCard
                    fullWidth
                    title="Notas fiscais em trânsito por status"
                  >
                    <InTransitInvoicesByStatus
                      onTime={data.invoicesInTransitByStatus.onTime}
                      lateOneDay={data.invoicesInTransitByStatus.lateOneDay}
                      lateTwoDays={data.invoicesInTransitByStatus.lateTwoDays}
                      lateThreeDays={data.invoicesInTransitByStatus.lateThreeDays}
                      forToday={data.invoicesInTransitByStatus.forToday}
                    />
                  </OperationalDashboardCard>
                </div>
                <div className="row OperationalDashboard__flex2 ">
                  <OperationalDashboardCard
                    fullWidth
                    title="No terminal em trânsito por estado"
                  >
                    <VerticalBarsByState
                      selector="tons"
                      sufix=""
                      states={data.invoicesInTransitByState.filter((state, key) => key < 10)}
                    />
                  </OperationalDashboardCard>
                </div>
              </div>
            </div>
          </div>
        }
      </OperationalDashboard>
    );
  }
}

const mapStateToProps = state => ({
  data: state.operationalDashboardDistribution.data,
  isFetching: state.operationalDashboardDistribution.isFetching,
});

const mapActionsToProps = {
  getDistributionData,
};

export default connect(mapStateToProps, mapActionsToProps)(Distribution);
